/**
 *
 */
var TouchPoint = (function () {
    function TouchPoint(x, y, id) {
        this.x = x;
        this.y = y;
        this.id = id;
    }
    return TouchPoint;
}());
export { TouchPoint };



// WEBPACK FOOTER //
// ../dist/lib/base/TouchPoint.js